import { LANGUAGES, LanguageCodes } from '@constants/language';

import { ILanguageOption } from './types';

export const DEFAULT_LOCALE: string = LanguageCodes.En;

export const LOCALIZATION_LANGUAGES: ILanguageOption[] = LANGUAGES.filter(
  (lang) => lang.key !== DEFAULT_LOCALE,
).map((lang) => ({ code: lang.key, name: lang.label }));

export const TOTAL_LOCALIZATION_LANGUAGES = LOCALIZATION_LANGUAGES.length;
